var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClockCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16 2C8.26875 2 2 8.26875 2 16C2 23.7313 8.26875 30 16 30C23.7313 30 30 23.7313 30 16C30 8.26875 23.7313 2 16 2ZM16 27.625C9.58125 27.625 4.375 22.4188 4.375 16C4.375 9.58125 9.58125 4.375 16 4.375C22.4188 4.375 27.625 9.58125 27.625 16C27.625 22.4188 22.4188 27.625 16 27.625Z",
  fill: "#383C3A"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.4596 19.9533L17.0034 16.7314V8.99707C17.0034 8.85957 16.8909 8.74707 16.7534 8.74707H15.2502C15.1127 8.74707 15.0002 8.85957 15.0002 8.99707V17.6033C15.0002 17.6846 15.0377 17.7596 15.1034 17.8064L20.2721 21.5752C20.3846 21.6564 20.5409 21.6314 20.6221 21.5221L21.5159 20.3033C21.5971 20.1877 21.5721 20.0314 21.4596 19.9533Z",
  fill: "#383C3A"
})));
export { SvgClockCircle as ReactComponent };
export default __webpack_public_path__ + "60e2fb768653d1d464da6548606a45be.svg";